import { addNote } from './add-note';
import { addTaxIdentifiers } from './add-tax-identifiers';
import { adjustWeight } from './adjust-weight';
import { doNotNotifyMarketplace } from './do-not-notify-marketplace';
import { salesOrder } from './sales-order';
import { shippingConfiguration } from './shipping-configuration';
import { templates } from './templates';

export const BulkActionRequestHandlers = [
  addNote,
  addTaxIdentifiers,
  adjustWeight,
  doNotNotifyMarketplace,
  salesOrder,
  shippingConfiguration,
  templates,
];
